import type { KpiCardSpec } from '~containers/analytics/kpis/card-spec';
import type { KpiSegment } from '~containers/analytics/kpis/types';

/**
 * The four chips of the Choice ratios block, a partition of the campaign:
 * every member falls in exactly one.
 */
export const CUSTOMER_GROUPS: readonly {
    segment: KpiSegment;
    label: string;
}[] = [
    { segment: 'ck-age-verified', label: 'CK Age verified' },
    { segment: 'ck-not-age-verified', label: 'CK Non-age verified' },
    { segment: 'ct-not-fuel-tester', label: 'CT Not fuel testers' },
    { segment: 'ct-fuel-tester', label: 'CT Fuel testers' },
];

export const DEFAULT_CUSTOMER_GROUP: KpiSegment = CUSTOMER_GROUPS[0].segment;

/**
 * The block's four cards, all on `campaign-segment-member` and all narrowed by
 * the group the block's selector holds (passed as a prop, not pinned here, so
 * the same four specs serve every chip).
 *
 * The two rate cards are deliberately not a `rate-trio` like their campaign
 * wide namesakes above: this endpoint serves one window, the page Period's.
 */
export const CUSTOMER_GROUP_CARDS: KpiCardSpec[] = [
    {
        title: 'Active members',
        source: 'campaign-segment-member',
        metric: 'activeMembers',
        form: 'number',
        size: 'sm',
        trend: false,
        description:
            'Fully enrolled members of the selected customer group with at least one transaction, not counting the automatic enrollment visit.',
    },
    {
        title: 'Share of campaign',
        source: 'campaign-segment-member',
        metric: 'shareOfCampaign',
        form: 'rate',
        size: 'sm',
        trend: false,
        description:
            "The group's active members over the campaign's own active members, read on the same period and region.",
    },
    {
        title: 'Coupon redemption rate',
        source: 'campaign-segment-member',
        metric: 'couponRedemptionRate',
        form: 'rate',
        size: 'sm',
        trend: false,
        description:
            'Share of milestone ladder coupons issued in the period to this group that were later redeemed. Not a slice of the campaign-wide card of the same name above: a coupon holder who is not enrolled, or whose phone cannot be normalized, belongs to no group, so the four groups together cover fewer coupons than that card does.',
    },
    {
        title: 'Member redemption rate',
        source: 'campaign-segment-member',
        metric: 'memberRedemptionRate',
        form: 'rate',
        size: 'sm',
        trend: false,
        description:
            "Share of this group's members granted a milestone ladder coupon in the period who redeemed at least one since. Not a slice of the campaign-wide card of the same name above, which also covers the coupon holders who belong to no group.",
    },
];
